function fetchStaffQuery ({startsWith, pageSize, page, filter}) {
  let variables = {
    pageSize: Number(pageSize) || 100,
    page: Number(page) || 1,
    startsWith: startsWith || '',
    filterFullName: filter.fullName || ''
  }

  if (filter && filter.organisationalUnit && Number(filter.organisationalUnit)) {
    variables['filterOrganisationalUnit'] = Number(filter.organisationalUnit)
  }

  return {
    operationName: 'fetchStaffQuery',
    query: `
      query fetchStaffQuery($startsWith:String!, $filterFullName:String, $filterOrganisationalUnit:Int, $pageSize:Int, $page:Int) {
        staff(filter: {organisationalUnit: $filterOrganisationalUnit, fullName: $filterFullName}, startsWith: $startsWith, pageSize: $pageSize, page: $page, sortOrder: ASC, orderBy: SURNAME) {
          meta {
            totalEntries
            decompositions {
              letterCount:groups {
                count
                name
              }
            }
          }
          entries {
            ... on Person {
              id:fisPersid
              label:_stringRep
              titel:title
              vorname:givenName
              name:surname
              organisationseinheiten:organisationalUnits {
                titelDe:titleDe
              }
            }
          }
        }
      }
    `,
    variables
  }
}

export { fetchStaffQuery }



// WEBPACK FOOTER //
// ./src/graphql/staff.js